import React, { Component } from 'react';
import { withRouter } from 'react-router';
import pathService from './PathService';
import { Button } from 'reactstrap';

class PathDeletePlain extends Component {
	constructor(props) {
		super(props);
		this.state = { users: [], loading: true };

		const { match } = this.props;
		this.id = match.params.id;
	}

	componentDidMount() {

	}

	handleClickOk = () => {
		const { history } = this.props;

		(async () => {
			await pathService.delete(this.id);
			history.push('/paths');
		})();
	}

	handleClickCancel = () => {
		const { history } = this.props;

		history.push('/paths');
	}

	render() {
		return (
			<div>
				<h2>Are you sure you want to delete path ?</h2>

				<button onClick={this.handleClickOk}>Yes</button>
				<button onClick={this.handleClickCancel}>No</button>
			</div>
		);
	}
}
export const PathDelete = withRouter(PathDeletePlain);